import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import store from '@/store';
// import multiguard from 'vue-router-multiguard';
// import { usePostHog } from '@/composables/posthog';
import {
  DASHBOARD_ROUTE,
  LOGIN_ROUTE,
  SIGNUP_PROFILE_ROUTE,
  SIGNUP_ORGANIZATION_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  NOT_FOUND_404_ROUTE,
  VERIFY_EMAIL_ROUTE,
  EMAIL_VERIFICATION_WALL_ROUTE,
  ERROR_ROUTE,
  SUPPORT_SESSION_ROUTE,
  ANNOUNCEMENTS_ROUTE,
  SET_PASSWORD_ROUTE,
  DISPLAY_ROUTE,
  SCREEN_SCHEDULE_DISPLAY_ROUTE,
  DONATIONS_ROUTE,
  EMAIL_ROUTE,
  TEXTS_ROUTE,
  ADD_ANNOUNCEMENT_ROUTE,
  EDIT_ANNOUNCEMENT_ROUTE,
  DUPLICATE_ANNOUNCEMENT_ROUTE,
  ADD_SHIUREI_TORAH_ROUTE,
  EDIT_SHIUREI_TORAH_ROUTE,
  DUPLICATE_SHIUREI_TORAH_ROUTE,
  ADD_DONATION_ROUTE,
  MEMBERS_ROUTE,
  MINYUNIM_ROUTE,
  ZMANIM_ROUTE,
  RICH_TEXT_EDITOR_TEST_ROUTE,
  EVENTS_ROUTE,
  ADD_TEMPLATE_ROUTE,
  TICKETS_ROUTE,
  POSTERS_ROUTE,
  API_KEYS_ROUTE,
  SETTINGS_ROUTE,
  DOCS_HOME_ROUTE,
  DOCS_SCREEN_ROUTE,
  DOCS_DONATION_ROUTE,
  DOCS_ANNOUNCEMENT_ROUTE,
  DOCS_KABBALAH_ROUTE,
  DOCS_AUTHENTICATION_ROUTE,
  DOCS_TEMPLATE_ROUTE,
  MINYANIM_COUNTDOWN_ROUTE,
  MINYANIM_ROLLS_N_ROUTE,
  ADD_MINYANIM_ROLL_N_ROUTE,
  EDIT_MINYANIM_ROLL_N_ROUTE,
  DUPLICATE_MINYANIM_ROLL_N_ROUTE,
  MINYANIM_N_ROUTE,
  ZMANIM_N_ROUTE,
  ADD_ZMANIM_N_ROUTE,
  EDIT_ZMANIM_N_ROUTE,
  DUPLICATE_ZMANIM_N_ROUTE,
  DONATIONS_N_ROUTE,
  ANNOUNCEMENTS_N_ROUTE,
  SHIUREI_TORAH_N_ROUTE,
  KABBALAH_N_ROUTE,
  KABBALAH_PUBLIC_FORM_ROUTE,
  KABBALAH_PUBLIC_FORM_LEGACY_ROUTE,
} from '@/router/routes';
import { ifNotAuthDeny } from '@/router/guards/not_auth';
import { installChunkReloadHandler } from '@/router/chunk_reload';
import { ifAuthDeny } from '@/router/guards/auth';
import DashboardView from '@/views/Dashboard.vue';
import LoginView from '@/views/auth/Login.vue';
// import { ifNotAdminDeny } from './guards/role';
import { DATE_TIME_BANNER_ROUTE } from './routes';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: DASHBOARD_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: DashboardView,
  },
  {
    path: '/login',
    name: LOGIN_ROUTE,
    beforeEnter: ifAuthDeny,
    component: LoginView,
  },
  // {
  //   path: '/signup-profile',
  //   name: SIGNUP_PROFILE_ROUTE,
  //   beforeEnter: ifAuthDeny,
  //   component: () => import('@/views/auth/Signup_Profile.vue'),
  // },
  // {
  //   path: '/signup-organization',
  //   name: SIGNUP_ORGANIZATION_ROUTE,
  //   beforeEnter: ifAuthDeny,
  //   component: () => import('@/views/auth/Signup_Organization.vue'),
  // },
  {
    path: '/forgot-password',
    name: FORGOT_PASSWORD_ROUTE,
    // beforeEnter: ifAuthDeny,
    component: () => import('@/views/auth/Forgot_Password.vue'),
  },
  {
    path: '/reset-password/:token',
    name: RESET_PASSWORD_ROUTE,
    // beforeEnter: ifAuthDeny,
    component: () => import('@/views/auth/Reset_Password.vue'),
  },
  {
    path: '/set-password/:token',
    name: SET_PASSWORD_ROUTE,
    // beforeEnter: ifAuthDeny,
    component: () => import('@/views/auth/Set_Password.vue'),
  },
  // {
  //   path: '/verify-email/:id',
  //   name: VERIFY_EMAIL_ROUTE,
  //   // beforeEnter: ifAuthDeny,
  //   component: () => import('@/views/auth/Verify_Email.vue'),
  // },
  // {
  //   path: '/email-verification-wall',
  //   name: EMAIL_VERIFICATION_WALL_ROUTE,
  //   // beforeEnter: ifNotAuthDeny,
  //   component: () => import('@/views/auth/Email_Verification_Wall.vue'),
  // },

  {
    path: '/announcements',
    name: ANNOUNCEMENTS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/announcement/Announcements.vue'),
  },
  {
    path: '/announcements/new',
    name: ADD_ANNOUNCEMENT_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/announcement/Register_Announcement.vue'),
  },
  {
    path: '/announcements/edit/:id',
    name: EDIT_ANNOUNCEMENT_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/announcement/Edit_Announcement.vue'),
  },
  {
    path: '/announcements/duplicate/:id',
    name: DUPLICATE_ANNOUNCEMENT_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/announcement/Duplicate_Announcement.vue'),
  },
  {
    path: '/shiurei-torah/new',
    name: ADD_SHIUREI_TORAH_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/shiurei_torah/Register_Shiurei_Torah.vue'),
  },
  {
    path: '/shiurei-torah/edit/:id',
    name: EDIT_SHIUREI_TORAH_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/shiurei_torah/Edit_Shiurei_Torah.vue'),
  },
  {
    path: '/shiurei-torah/duplicate/:id',
    name: DUPLICATE_SHIUREI_TORAH_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/shiurei_torah/Duplicate_Shiurei_Torah.vue'),
  },
  {
    path: '/announcement-old',
    name: 'ANNOUNCEMENTS_ROUTE_OLD',
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Announcements-Old.vue'),
  },
  {
    path: '/donations',
    name: DONATIONS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/donation/Donations.vue'),
  },
  {
    path: '/donations/new',
    name: ADD_DONATION_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/donation/Add_Donation.vue'),
  },
  {
    path: '/display/:id',
    name: DISPLAY_ROUTE,
    // beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Display.vue'),
  },
  {
    // A screen schedule's own link. Public like the screen link above, and it
    // never replaces it: each screen keeps /display/:id, which does not switch.
    path: '/display/schedule/:id',
    name: SCREEN_SCHEDULE_DISPLAY_ROUTE,
    component: () => import('@/views/Screen_Schedule_Display.vue'),
  },
  {
    path: '/members',
    name: MEMBERS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/member/Members.vue'),
  },
  {
    path: '/minyunim',
    name: MINYUNIM_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/minyanim/Minyanim.vue'),
  },
  {
    path: '/zmanim',
    name: ZMANIM_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/zmanim/Zmanim.vue'),
  },
  {
    path: '/texts',
    name: TEXTS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Text.vue'),
  },
  {
    path: '/template/add',
    name: ADD_TEMPLATE_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/template/Add_Template.vue'),
  },
  {
    path: '/email',
    name: EMAIL_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Email.vue'),
  },
  {
    path: '/minyanim',
    name: MINYANIM_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Minyamin_N/Minyanim_N.vue'),
  },
  {
    path: '/minyanim-countdown',
    name: MINYANIM_COUNTDOWN_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/minyanim_countdown/Minyanim_Countdown.vue'),
  },
  {
    path: '/events',
    name: EVENTS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/event/events.vue'),
  },
  {
    path: '/posters',
    name: POSTERS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/poster/Poster.vue'),
  },
  {
    path: '/tickets',
    name: TICKETS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/ticket/Tickets.vue'),
  },
  {
    path: '/date-time-banner',
    name: DATE_TIME_BANNER_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/date_time_banner/Date_Time_Banner.vue'),
  },
  {
    path: '/api-keys',
    name: API_KEYS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/api_keys/API_Keys.vue'),
  },
  {
    path: '/settings',
    name: SETTINGS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/settings/Settings.vue'),
  },
  {
    path: '/minyanim-rolls',
    name: MINYANIM_ROLLS_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Minyamin_N/Minyanim_Rolls/Minyanim_Rolls_N.vue'),
  },
  {
    path: '/minyanim-rolls/add',
    name: ADD_MINYANIM_ROLL_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Minyamin_N/Minyanim_Rolls/Add_Minyanim_Roll.vue'),
  },
  {
    path: '/minyanim-rolls/edit/:id',
    name: EDIT_MINYANIM_ROLL_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Minyamin_N/Minyanim_Rolls/Edit_Minyanim_Roll.vue'),
  },
  {
    path: '/minyanim-rolls/duplicate/:id',
    name: DUPLICATE_MINYANIM_ROLL_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Minyamin_N/Minyanim_Rolls/Duplicate_Minyanim_Roll.vue'),
  },
  {
    path: '/zmanim_N',
    name: ZMANIM_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Zmanm_N/Zmanim_N.vue'),
  },
  {
    path: '/zmanim_N/add',
    name: ADD_ZMANIM_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Zmanm_N/Add_Zmanim_N.vue'),
  },
  {
    path: '/zmanim_N/edit/:id',
    name: EDIT_ZMANIM_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Zmanm_N/Edit_Zmanim_N.vue'),
  },
  {
    path: '/zmanim_N/duplicate/:id',
    name: DUPLICATE_ZMANIM_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Zmanm_N/Duplicate_Zmanim_N.vue'),
  },
  {
    path: '/donations_N',
    name: DONATIONS_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Donation_N/Donations_N.vue'),
  },
  {
    path: '/announcements_N',
    name: ANNOUNCEMENTS_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Announcement_N/Announcements_N.vue'),
  },
  {
    path: '/shiurei_torah_N',
    name: SHIUREI_TORAH_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Shiurei_Torah_N/Shiurei_Torah_N.vue'),
  },
  // {
  //   path: '/rich-text-editor-test',
  //   name: RICH_TEXT_EDITOR_TEST_ROUTE,
  //   beforeEnter: ifNotAuthDeny,
  //   component: () => import('@/views/Rich_Text_Editor_Test.vue'),
  // },
  {
    path: '/kabbalah',
    name: KABBALAH_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Kabbalah_N/Kabbalah_N.vue'),
  },
  // The organization's shareable Kabbalah form. Public by design — no guard,
  // since the people filling it in have no account. Declared after the admin
  // route above so the literal `/kabbalah` still wins.
  {
    path: '/kabbalah/:organizationName',
    name: KABBALAH_PUBLIC_FORM_ROUTE,
    component: () => import('@/views/Kabbalah_N/Kabbalah_Public_Form.vue'),
  },
  // The shape the link had before it was shortened. Kept so a QR code or flyer
  // printed with the id on it still opens the form — that path resolves by id,
  // which also survives the organization being renamed.
  {
    path: '/kabbalah/:organizationName/:organizationId',
    name: KABBALAH_PUBLIC_FORM_LEGACY_ROUTE,
    component: () => import('@/views/Kabbalah_N/Kabbalah_Public_Form.vue'),
  },
  {
    // Where the Screenkode admin opens this app for a support session: in a
    // frame, signed in over postMessage (utils/support_session). No guard —
    // the page signs in by itself.
    path: '/support-session',
    name: SUPPORT_SESSION_ROUTE,
    component: () => import('@/views/auth/Support_Session.vue'),
  },
  {
    path: '/error',
    name: ERROR_ROUTE,
    component: () => import('@/views/Error.vue'),
  },

  // API DOcs
  {
    path: '/docs',
    name: DOCS_HOME_ROUTE,
    // beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/docs/Overview.vue'),
  },
  {
    path: '/docs/authentication',
    name: DOCS_AUTHENTICATION_ROUTE,
    // beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/docs/Authentication.vue'),
  },
  {
    path: '/docs/screen',
    name: DOCS_SCREEN_ROUTE,
    // beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/docs/Screen.vue'),
  },
  {
    path: '/docs/template',
    name: DOCS_TEMPLATE_ROUTE,
    // beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/docs/Template.vue'),
  },
  {
    path: '/docs/donation',
    name: DOCS_DONATION_ROUTE,
    // beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/docs/Donation.vue'),
  },
  {
    path: '/docs/announcement',
    name: DOCS_ANNOUNCEMENT_ROUTE,
    // beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/docs/Announcement.vue'),
  },
  {
    path: '/docs/kabbalah',
    name: DOCS_KABBALAH_ROUTE,
    // beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/docs/Kabbalah.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: NOT_FOUND_404_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Recover from stale code-split chunks after a deploy (see chunk_reload.ts).
installChunkReloadHandler(router);


// const { posthog } = usePostHog();

// router.afterEach(() => {
//   store.dispatch(UPDATE_ROUTER_LOADER, false);
//   posthog.capture('$pageview');
// });

// router.beforeEach((to, from) => {
//   if (from.path !== to.path) {
//     posthog.capture('$pageleave');
//   }
// });

export default router;
